import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom';
import { ApiError } from '@/lib/api-client';

/** Route-level error element. Renders thrown ApiError / router errors nicely. */
export function RouteError() {
  const error = useRouteError();

  let title = '문제가 발생했습니다';
  let message = '잠시 후 다시 시도해 주세요.';

  if (error instanceof ApiError) {
    title = `오류 ${error.status}`;
    message = error.message;
  } else if (isRouteErrorResponse(error)) {
    title = `${error.status} ${error.statusText}`;
    message = error.status === 404 ? '페이지를 찾을 수 없습니다.' : message;
  } else if (error instanceof Error) {
    message = error.message;
  }

  return (
    <div className="container flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center">
      <h1 className="text-3xl font-bold">{title}</h1>
      <p className="text-muted-foreground">{message}</p>
      <Link
        to="/"
        className="inline-flex h-10 items-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground hover:bg-primary/90"
      >
        홈으로 돌아가기
      </Link>
    </div>
  );
}
